import React from 'react';
import Icon from '../../../../../muiComponents/Icon';

interface NavigationArrowsProps {
    onPrevClick: () => void;
    onNextClick: () => void;
    isPrevActive: boolean;
    isNextActive: boolean;
}
const NavigationArrows = (props: NavigationArrowsProps) => {
    const { onPrevClick, onNextClick, isPrevActive, isNextActive } = props;
    return (
        <>
            {isPrevActive ? (
                <Icon
                    className='carousel__button --left'
                    iconName='KeyboardArrowLeft'
                    onClick={onPrevClick}
                />
            ) : null}
            {isNextActive ? (
                <Icon
                    className='carousel__button --right'
                    iconName='KeyboardArrowRight'
                    onClick={onNextClick}
                />
            ) : null}
        </>
    );
};

export default NavigationArrows;
